var map = {
	"./aro-kraken-ant.png": 5279,
	"./aro-kraken.png": 8223,
	"./bespoke.jpg": 2291,
	"./brain-map.png": 6127,
	"./brain-mapb.jpg": 5789,
	"./brain-mapb.png": 2621,
	"./brain.png": 4354,
	"./brain.svg": 2842,
	"./chat.png": 66,
	"./contact.jpg": 7230,
	"./design_decogaia.jpg": 5722,
	"./design_design_tiradas.jpg": 3974,
	"./design_factures_mobile.jpg": 4403,
	"./design_geotagger.jpg": 502,
	"./design_movie.jpg": 7847,
	"./design_proweels.jpg": 2534,
	"./design_qgourmetcafe.jpg": 2044,
	"./design_soundspot.jpg": 5018,
	"./design_tpintxo.jpg": 8955,
	"./design_uss.jpg": 2200,
	"./desings-segurost.jpg": 8872,
	"./kkweb.svg": 2722,
	"./klinks.jpg": 9318,
	"./klinksh.jpg": 3332,
	"./left-w.png": 1147,
	"./left.png": 1227,
	"./locker.jpg": 800,
	"./login.jpg": 5885,
	"./mmanresa-min.jpeg": 2732,
	"./mountains-a.jpg": 220,
	"./mountains-large.png": 8836,
	"./mountains-min.png": 6865,
	"./mountains.png": 330,
	"./mountains3.png": 491,
	"./mountainsbig.png": 3794,
	"./noise.png": 808,
	"./nojunkm.jpg": 1850,
	"./octopus.jpg": 641,
	"./setup.jpg": 8737,
	"./setup2.jpg": 9263,
	"./ship.jpg": 6250,
	"./tap.png": 6053,
	"./tecnicart.jpg": 5307,
	"./tentaculo-g.png": 6129,
	"./tentaculo-n.png": 2848,
	"./tentaculo.png": 8037,
	"./tentaculob.png": 1475
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1382;